import React, { useEffect } from "react";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Time as TimeIcon,
  VoiceIcon,
  Location,
  Calender,
} from "../../../components/svgs";
import {
  StyledText,
  MainHolder,
  Children,
  Body,
  DynamicButton,
} from "../../../components/common/basic";
import { BackButton, FeatureHeader } from "../../../components/common";
import useYPYC from "../ypyc/hooks/useYPYC";

const iconMap = {
  time: TimeIcon,
  calendar: Calender,
  location: Location,
  edit: VoiceIcon,
};

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

const JustBeHome = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "JustBeSeriesHome",
        firebase_screen_class: "JustBeSeriesHome",
      })
    );
  }, []);

  const {
    background,
    history,
  } = useYPYC();

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <FeatureHeader
            image={`${SERVER_URL}/assets/images/jbs-oct-2023-banner.jpg`}
            title={["The Future of E-Commerce: Trends and Opportunities "]}
            background={"#fff"}
            secondaryBackground={"#fff"}
          ></FeatureHeader>

          <Body>
            <div
              style={{
                boxSizing: "border-box",
                padding: "10px 15px 70px 15px",
              }}
            >
              <IconList
                Icon={iconMap.calendar}
                title={"October 21, 2023"}
                description={"Saturday"}
                color={background}
              />
              <HorizontalLine />

              <div>
                <StyledText
                  size={12}
                  style={{ fontFamily: "MTNRegular", margin: "0 0 10px 0" }}
                >
                  Dear Friend<br /><br />

                  The 6th Edition of MTN Pulse Just Be Series is here and happening on  Saturday, October 21, 2023.<br /><br />

                  Discussions for this year's edition is centered on The Future of E-Commerce: Trends and Opportunities .<br /><br />

                  Register here to reserve a seat:
                  <a href="https://forms.gle/4LYp274bNGpmATVX8">https://forms.gle/4LYp274bNGpmATVX8</a><br /><br />

                  This year, MTN Pulse is giving 10 free slots to Vendors to exhibit their products at the program.<br /><br />

                  Register here to be considered and selected for the exhibition:
                  <a href="https://forms.gle/ZKBzkox376bgXSFWA">https://forms.gle/ZKBzkox376bgXSFWA.</a><br /><br />

                  Kindly note that selection would be based on availability of slots of categorised products.
                </StyledText>
              </div>

              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  background: "#fff",
                  borderTop: "1px solid #ddd",
                }}
              >
                <div style={{ padding: "10px 30px" }}>
                  <DynamicButton
                    onClick={() => {
                      history.push("/loyalty/livestream");
                    }}
                    label={
                      "Watch Live"
                    }
                    color={
                      "#0FAF4B"
                    }
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const IconList = ({ Icon, title, description, color }) => (
  <div style={{ display: "flex", alignItems: "top", marginBottom: "15px" }}>
    <div
      style={{
        width: "16px",
        marginRight: "10px",
      }}
    >
      <Icon fill={color} width={16} height={16} />
    </div>
    <div>
      <StyledText
        size={14}
        style={{ fontFamily: "MTNBold", margin: "0 0 2px 0" }}
      >
        {title}
      </StyledText>
      <StyledText size={12} style={{ fontFamily: "MTNRegular", margin: "0" }}>
        {description}
      </StyledText>
    </div>
  </div>
);

const HorizontalLine = styled.div`
  margin: 20px 0;
  border-top: none;
  border-bottom: 1px solid #ddd;
`;

export default JustBeHome;
